import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const resetCustomizationData = async () => {
  return axiosPrivate.post(`/dashboard/api/v1/checkout-customization/reset`, {});
};